import api from './api';
import FBPixel from './FBPixel';

const endpoint = '/api/v1/ecommerce/order';

export default {

    add(type, terms, shipping, billing, sameas, card, newsletter, customerStatus, fulfillmentOption, calculatedTotal, captchaResponse) {
        return api.post(endpoint, {
            type: type,
            terms: terms,
            shipping: shipping,
            billing: billing,
            sameas: sameas,
            card: card,
            newsletter: newsletter,
            customerStatus: customerStatus,
            fulfillmentOption: fulfillmentOption,
            calculatedTotal: calculatedTotal,
            captchaResponse: captchaResponse,
        });
    },

    firePixelEvent(cartContents, amount, email) {
        return new Promise((resolve, reject) => {
            if (cartContents == null) {
                reject('No cart contents or contents not valid array');
                for(let i =0;i<20; i++){
                console.log('NO CART CONTENT');
                }
                return;
            }

            let contentIds = [];
            const gtagItems = [];

            for (let productKey in cartContents) {
                let item = cartContents[productKey];

                const gtagItem = {
                id: item.id,
                item_name: item.name,
                quantity: item.qty,
                item_price: item.price,
                };

                gtagItems.push(gtagItem);

                if (item &&
                    item.product &&
                    item.product.model
                ) {
                    console.log('Adding content_id: ', item.product.model);
                    contentIds.push(item.product.model);
                } else {
                    console.log('Product info missing for item: ', item.id ? item.id : 'n/a');
                }
            }

            let pixelData = {
                user_email: email,
                event_name: "Purchase",
                currency: "USD",
                value: amount,
                content_ids: contentIds,
                content_type: 'product',
                // url: window.location.href,
                // event_id: FBPixel.generateFbEid(),
                // fb_clid: FBPixel.grabFbClid()
            };

            try {
                if (gtag) {
                    gtag('event', 'purchase', 
                    {
                        'x-fb-event_id': `${Math.floor(Date.now() / 1000)}`,
                        'currency': 'USD',
                        'value': amount,
                        user_data: {
                            email_address: email,
                        },
                        items: gtagItems, 
                    });
                }
            } catch (error) {
                console.log('Error firing gtag event: ', error);
            }

            //For debug
            //console.log(`Sent facebook pixel event with the following data: ${JSON.stringify(pixelData)}`);
            return FBPixel.sendEvent('Purchase', pixelData).then(
                function(success){
                    resolve(success);
                }, function (error) {
                    console.log(`Error occurred in pixel event, resolving anyway to prevent issues with checkout: ${error}`);
                    //Don't reject because it will cause the purchase flow to fail altogether
                    resolve(error);
                }
            );
        });
    },
}
